import { cn } from '@zep/utils';
export function PaymentTypeText({
  text,
  className
}: {
  text: string;
  className?: string;
}) {
  return <span className={cn('text-body-1-sb text-[14px] font-[600] text-gray-900', className)} data-sentry-component="PaymentTypeText" data-sentry-source-file="PaymentTypeText.tsx">
      {text}
    </span>;
}